import {
  Drawer,
  FontAwesomeIcon,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  VeBox,
  VeTypography,
  styled,
  useMediaQuery,
} from "@packages/ui/mui";
import {
  HELP,
  PROFILE_DOTS,
  SETTINGS,
  SETTINGS_ACTIVE,
  VE_TEXTICON,
} from "@public/index";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import DrawerData from "./drawerData";
import {
  faAngleLeft,
  faAnglesLeft,
  faArrowRightFromBracket,
} from "@packages/ui/libs";
import { limiter } from "@packages/ui/hoc";
import { ProfileIcon, VeSearch } from "@packages/ui/components";
import { useRouter } from "next/navigation";
import { signOut } from "next-auth/react";
import { useData } from "@providers/context";
import { clearLocalStorageExcept } from "@libs/helper";

const DrawerHeader = styled("div")(({ theme }: any) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

interface MenuItemData {
  text: string;
  path?: string;

  icon?: JSX.Element;
  selectedIcon?: JSX.Element;
  subItems?: MenuItemData[];
}

interface ProfileItemData {
  label: string;
  path?: string;
  icon?: JSX.Element;
  selectedPath?: string;
  click?: () => void;
}

const TabDrawerUser = ({
  mobileOpen,
  handleDrawerClose,
  handleDrawerTransitionEnd,
  open,
  selectedItem,
  childSelected,
  handleItemClick,
  setChildSelected,
  pathName,
  setIsHovered,
  anchorElUser,
  handleCloseUserMenu,
  handleOpenUserMenu,
  data,
}: {
  mobileOpen: any;
  handleDrawerClose: any;
  handleDrawerTransitionEnd: any;
  anchorElUser: any;
  handleCloseUserMenu: any;
  handleOpenUserMenu: any;
  data?: any;
  selectedItem: string;
  childSelected: string;
  handleItemClick: (text: string, subItems?: MenuItemData[]) => void;
  setChildSelected: (text: string) => void;
  setIsHovered: any;
  pathName?: string;
  open: boolean;
}) => {
  const router = useRouter();
  const [search, setSearch] = React.useState<string>("");

  const settings: ProfileItemData[] = [
    {
      label: "Profile",
      path: "/profile",
      selectedPath: "/fainfo",
      click: () => {
        router.push("/setting-profile?section=0");
      },
    },
    {
      label: "Sign Out",
      path: "/signOut",
      icon: (
        <FontAwesomeIcon
          icon={faArrowRightFromBracket}
          flip="horizontal"
          style={{ color: "#5f6368" }}
        />
      ),
      click: () => {
        clearLocalStorageExcept();
        sessionStorage.clear();
        signOut();
      },
    },
  ];

  const isMobile = useMediaQuery("(max-width: 600px)");

  const { currentRole } = useData();
  const drawerWidth = currentRole === "INVESTOR" ? 220 : 360;

  const handleSearch = (e: any) => {
    setSearch(e.target.value);
  };

  const clearSearchFunction = () => {
    setSearch("");
  };

  return (
    <Drawer
      variant="temporary"
      open={mobileOpen}
      onTransitionEnd={handleDrawerTransitionEnd}
      onClose={handleDrawerClose}
      className="mobile/tab drawer"
      ModalProps={{
        keepMounted: true,
      }}
      sx={{
        display: "block",
        "@media (min-width: 900px)": {
          display: "none",
        },
        "& .MuiDrawer-paper": {
          boxSizing: "border-box",
          width: isMobile ? "100%" : drawerWidth, // change width here for tab / mobile
        },
      }}
    >
      <DrawerHeader
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "flex-start",
          padding: "16px",
          gap: "8px",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <IconButton
          onClick={handleDrawerClose}
          sx={{
            width: "24px",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FontAwesomeIcon
            style={{ width: "8px !important", height: "14px !important" }}
            icon={faAngleLeft}
            size="xs"
          />
        </IconButton>

        <VeTypography variant="label1StrongerSecondary">Menu</VeTypography>
      </DrawerHeader>
      <VeBox
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        padding={"16px"}
      >
        <VeSearch
          name="search"
          placeHolder="Search menu"
          search
          value={search}
          onChange={handleSearch}
          clearSearch={search?.length > 0}
          clearSearchFunction={clearSearchFunction}
        />
      </VeBox>
      <DrawerData
        pathName={pathName}
        selectedItem={selectedItem}
        childSelected={childSelected}
        handleItemClick={handleItemClick}
        setChildSelected={setChildSelected}
        open={mobileOpen}
        search={search}
        setSearch={setSearch}
        handleDrawerClose={handleDrawerClose}
      />
    </Drawer>
  );
};

export default TabDrawerUser;
